<script lang="ts" setup>
import CasinoDirect from './casino-direct.vue'
import CasinoIndirect from './casino-indirect.vue'
import LiveStream from '~/components/common/casino/live-stream.vue'
import LoadingSpin from '~common/loading-spin.vue'
import SearchForm from '~common/search-form.vue'
import { useCasino } from '~/composables/casino/use-casino'

const {
  limit,
  provider,
  category,
  loadMore,
  providers,
  categories,
  totalGames,
  gamesToShow,
  loadingClass,
  keywordSearch,
  indirectGames,
  selectProvider,
  selectCategory,
  playCasinoGame,
  playGameIndirect
} = useCasino()
</script>

<template>
  <div class="live-casino">
    <LoadingSpin v-if="loadingClass" />

    <template v-else>
      <div class="wrapper-search">
        <SearchForm v-model="keywordSearch" />
      </div>
      <CasinoDirect
        :isLoading="loadingClass"
        :provider="provider"
        :category="category"
        :providers="providers"
        :categories="categories"
        :gamesToShow="gamesToShow"
        :limit="limit"
        :totalGames="totalGames"
        :keywordSearch="keywordSearch"
        @selectProvider="selectProvider"
        @selectCategory="selectCategory"
        @playCasinoGame="playCasinoGame"
        @loadMore="loadMore"
      />

      <LiveStream class="mt-0 px-3" />

      <CasinoIndirect :indirectBetting="indirectGames" @playGameIndirect="playGameIndirect" />
    </template>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/casino/index.scss';
</style>
